//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryUserTreeList } from '@/api/api';
import safeProductionDrawer from "./modules/safeProductionDrawer";
export default {
  name: 'WorkPlanList',
  mixins: [JeecgListMixin],
  components: {
    safeProductionDrawer: safeProductionDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/work/safety',
      pageTitle: '安全生产',
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      userTree: [],
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'category_dictText',
        colName: 'categoryDictText',
        title: '作业类别',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'departName',
        colName: 'departName',
        title: '作业单位',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'responsible_userName',
        colName: 'responsibleUserName',
        title: '负责人',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'time',
        colName: 'time',
        title: '作业时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'content',
        colName: 'content',
        title: '作业内容',
        align: 'center'
      }, {
        dataIndex: 'verifyUser_userName',
        colName: 'verifyUserUserName',
        title: '审核人',
        align: 'center'
      }, {
        dataIndex: 'verifyState_dictText',
        colName: 'verifyStateDictText',
        title: '审核状态',
        align: 'center'
      }, {
        dataIndex: 'verifyComments',
        colName: 'verifyComments',
        title: '审核意见',
        align: 'center'
      }, {
        dataIndex: 'createBy_userName',
        colName: 'create_by',
        title: '创建用户',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 240,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    this.loadTreeList();
  },
  computed: {},
  methods: {
    handleDetail: function handleDetail(record) {
      this.$refs.modalForm.edit(record, 3);
      this.$refs.modalForm.title = this.pageTitle + '详情';
      this.$refs.modalForm.disableSubmit = true;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = false;
    },
    handleData: function handleData(record, type) {
      this.$refs.modalForm.edit(record, type);
      this.$refs.modalForm.title = '编辑：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = true;
      this.$refs.modalForm.handledDataState = handledDataState;
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    onDateStartTime: function onDateStartTime(value, dateArray) {
      this.queryParam.startTime = dateArray[0];
      this.queryParam.endTime = dateArray[1];
    }
  }
};